import React from 'react';
import { useHistory } from 'react-router-dom';
import CekHargaL from './../assets/images/img_car01.png';
import CekHargaR from './../assets/images/img_car02.png';
import { StepCekHarga } from './FilterCekHarga';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import '../css/checkprice.scss';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Car from '../assets/images/wingr.png';

const CekHarga = () => {
  let history = useHistory();

  return (
    <>
      <div className="page-checkharga overview-page">
        <TopNav pageChannel="Cek Harga" />
        <div className="container-fluid main-overview">
          <div className="row">
            <Sidebar height={'150vh'} pageChannel="Cek Harga" />
            <div className="col-xl-10 col-lg-12 pt-3 content">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb ml-2">
                  <li className="breadcrumb-item">
                    <b>
                      <a
                        style={{ textDecoration: 'none', color: '#82be2a', cursor: 'pointer' }}
                        onClick={() =>
                          history.push({
                            pathname: '/',
                            state: {
                              pageChannel: 'Cek Harga',
                            },
                          })
                        }
                      >
                        Overview
                      </a>
                    </b>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Cek Harga Kendaraan
                  </li>
                </ol>
              </nav>
              <div className="row mx-4 py-4" style={{ backgroundColor: '#82be2a' }}>
                <div className="col-xl-3 pt-4 text-center">
                  <img src={CekHargaL} width="200" height="100" />
                </div>
                <div className="col-xl-6 py-4 text-center text-light">
                  <h6>Ingin Tahu Harga Kendaraan Anda?</h6>
                  <h5>Temukan Harga Kendaraan Anda di Sini</h5>
                </div>
                <div className="col-xl-3 pt-4 text-center">
                  <img src={CekHargaR} width="200" height="100" />
                </div>
              </div>
              <div className="row mx-4">
                <div className="col-xl-12 bg-light py-4">
                  <StepCekHarga />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-checkharga-mobile">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header">
              <FontAwesomeIcon
                onClick={() => {
                  history.replace({ pathname: '/', state: { pageChannel: 'Cek Harga' } });
                }}
                className="mb-2"
                icon={faArrowLeft}
              />
              <h4 className="ml-5" style={{ fontSize: '6vw' }}>
                Cek Harga Kendaraan
              </h4>
            </div>
          </div>
          <div className="row">
            <div
              className="col-12 d-flex flex-column align-items-center pt-3 pb-3 text-light header text-center"
              style={{ backgroundColor: '#a3cf62' }}
            >
              <img src={Car} style={{ width: 200, height: 120 }} />
              <label className="mt-1">Ingin Tahu Harga Kendraan Anda?</label>
              <h6 style={{ fontWeight: 700 }}>Temukan Harga Kendaraan Anda Disini</h6>
            </div>
          </div>
          <div className="row">
            <StepCekHarga />
          </div>
        </div>
      </div>
    </>
  );
};

export default CekHarga;
